module.exports = __webpack_public_path__ + "static/media/sensable_8.07cd2826.gif";